import React from 'react';
import VerticalAccordion from '../../../../modules/VerticalAccordion';
import VerticalAccordionTitle from '../../../../modules/VerticalAccordionTitle';
import VerticalAccordionBody from '../../../../modules/VerticalAccordionBody';
import InspectionDetailPropertyDetails from './InspectionDetailPropertyDetails';
import { useInspectionDetailContext } from '../InspectionDetailProvider';
const InspectionDetailPropertyOverviewAccordion = (props) => {
    const { isPopulatingData } = useInspectionDetailContext();
    return (React.createElement(VerticalAccordion, null,
        React.createElement(VerticalAccordionTitle, null, "Property overview"),
        React.createElement(VerticalAccordionBody, null,
            React.createElement(InspectionDetailPropertyDetails, { isLoading: isPopulatingData, inspection: props.inspection }))));
};
export default InspectionDetailPropertyOverviewAccordion;
